export default __webpack_public_path__ + "static/media/step2-3.10c76340.png";